import { apiService } from './index';
import { IRegisterUser } from '../shared/types/auth';
import { User, UserFilter } from '../shared/types/user';

export const asyncPostUser = async (formUser: IRegisterUser) => {
    return await apiService.post('/api/users', formUser);
};

export const asyncGetUsers = async (
    filters?: UserFilter,
    page?: number,
    pageSize?: number
) => {
    return await apiService.get('/api/users', {
        limit: pageSize || 20,
        page: page || 0,
        ...filters,
    });
};

export const asyncGetUsersSimple = async (): Promise<{
    items: User[];
    length: number;
}> => {
    try {
        const {
            items: data,
        }: {
            items: { items: User[]; length: number };
        } = await apiService.get('/api/users/simple');

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncGetUsersByProject = async (
    projectId: string
): Promise<{ items: User[]; length: number }> => {
    try {
        const {
            items: data,
        }: {
            items: { items: User[]; length: number };
        } = await apiService.get('/api/users/by-project', { projectId });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncDeleteUser = async (id: string) => {
    return await apiService.delete(`/api/users/${id}`);
};

export const asyncReactivateUser = async (id: string) => {
    return await apiService.patch(`/api/users/reactivate/${id}`);
};

export const asyncUpdateProfileImage = async (
    id: string,
    payload: { base64: string; originalname: string }
) => {
    return await apiService.patch(
        `/api/users/update-profile-image/${id}`,
        payload
    );
};

export const asyncGetUser = async (id: string | undefined) => {
    return await apiService.get(`/api/users/${id}`);
};

export const asyncPatchtUser = async (id: string, formUser: any) => {
    return await apiService.patch(`/api/users/${id}`, formUser);
};

export const asyncGetMyUser = async (email: string): Promise<any> => {
    try {
        const user = await apiService.get<User>('/api/users/me', { email });
        return user;
    } catch (error) {
        return null;
    }
};
